/**
 * 애플리케이션 전역에서 사용되는 제한값(Limit) 상수들
 */

// ==================== 페이지네이션 ====================
/** 한번에 보이는 페이지 번호 개수
 * 사용처: 
 *  PageAboutText
 *  PageAboutWork
 *  PageAboutImport
 *  PageAboutMember
 *  PageAboutSupport 
 * */
export const LIMIT_PAGE_NUM = 5;

// ==================== 입력 필드 길이 제한 (UI)====================
/** 인증 코드 최대 길이
 * 사용처: 
 *  EmailVerification
 *  EmailVerificationMobile
 *  DeferredEmailVerification
 *  DeferredEmailVerificationMobile
 * */
export const INPUT_VERIFICATION_CODE_MAX_LENGTH = 1;
/** Year 필드 길이 (고정)
 * 사용처: WorkViewer, TextViewer, WorkInfo(PE))
 */
export const INPUT_YEAR_MIN_LENGTH = 5;
export const INPUT_YEAR_MAX_LENGTH = 5;

/** Work 태그 이름 (백엔드와 동일: 코드 포인트 기준 최대 길이) */
export const INPUT_TAG_NAME_MAX_LENGTH = 30;

/** Material 필드 최소/최대 길이
 * 사용처: WorkViewer, WorkInfo(PE)
 * min/max는 input 너비(ch)용. WorkViewer Material 편집은 textarea + CSS wrap.
 * */
export const INPUT_MATERIAL_MIN_LENGTH = 14;
export const INPUT_MATERIAL_MAX_LENGTH = 30;

/** Material 편집 textarea 최대 시각 행 수 (Enter 불가, CSS wrap 기준)
 * 사용처:
 *  MoleculeTextAreaDiv (WorkViewer Material, WorkInfo(PE) Material)
 * */
export const INPUT_MATERIAL_MAX_ROWS = 6;

/** Running Time 필드 최소/최대 길이
 * 사용처: 
 *  WorkViewer
 * */
export const INPUT_RUNNING_TIME_MIN_LENGTH = 16;
export const INPUT_RUNNING_TIME_MAX_LENGTH = 30;

/** Running Time 필드 최소/최대 길이 (Project Element Work 인포)
 * 사용처: WorkInfo, WorkInfoLeft, WorkInfoRight, WorkInfoMobile
 * */
export const INPUT_RUNNING_TIME_MIN_LENGTH_PE = 8;
export const INPUT_RUNNING_TIME_MAX_LENGTH_PE = 16;

/** Collection 필드 최소/최대 길이
 * 사용처: 
 *  WorkViewer
 * */
export const INPUT_COLLECTION_MIN_LENGTH = 9;
export const INPUT_COLLECTION_MAX_LENGTH = 14;

/** Price 필드 최소/최대 길이
 * 사용처: 
 *  PriceInput
 * */
export const INPUT_PRICE_MIN_LENGTH = 7;
export const INPUT_PRICE_MAX_LENGTH = 14;

/** Size 필드 최소/최대 길이
 * 사용처: 
 *  SizeInput (width, height, depth)
 * */
export const INPUT_SIZE_MIN_LENGTH = 1;
export const INPUT_SIZE_MAX_LENGTH = 6;

/** SizeText 필드 최소/최대 길이
 * 사용처: WorkViewer, WorkInfo(PE)
 * */
export const INPUT_SIZE_TEXT_MIN_LENGTH = 14;
export const INPUT_SIZE_TEXT_MAX_LENGTH = 30;

export const WORK_SIZE_TEXT_MAX_LENGTH = 500;

/** Admin member email 본문 최대 길이 */
export const ADMIN_MEMBER_EMAIL_BODY_MAX_LENGTH = 10000;

// ==================== 텍스트 길이 제한 (DB 제한)====================
/** 프로젝트 커스텀 이름 최대 길이
 * 사용처: 
 *  ProjectInfo
 *  ProjectInfoMobile
 *  OnBoardingProjectInfoItem
 *  OnBoardingProjectInfoItemMobile
 * */
export const PROJECT_INFO_NAME_MAX_LENGTH = 20;

/** 프로젝트 커스텀 값(text) 최대 길이
 * 사용처: 
 *  ProjectInfo
 *  ProjectInfoMobile
 *  OnBoardingProjectInfoItem
 *  OnBoardingProjectInfoItemMobile
 * */
export const PROJECT_INFO_VALUE_MAX_LENGTH = 100;

/** Active Date 기간의 종료 문구 최대 길이 */
export const PROJECT_INFO_DATE_END_TEXT_MAX_LENGTH = 80;

/** 프로젝트 커스텀 값 url 최대 길이
 * 사용처:
 *  ProjectInfo
 *  ProjectInfoMobile
 * */
export const PROJECT_INFO_URL_MAX_LENGTH = 2000;

/** Detail Description 최대 길이
 * 사용처: 
 *  WorkDetail
 *  DetailInfo
 *  DetailInfoRight
 *  DetailInfoLeft
 * */
export const DETAIL_DESCRIPTION_MAX_LENGTH = 100;

/** Document Description 최대 길이
 * 사용처: 
 *  DocumentInfo
 *  DocumentInfoRight
 *  DocumentInfoLeft
 *  OnBoardingDocumentInfo
 *  OnBoardingDocumentInfoRight
 *  OnBoardingDocumentInfoLeft
 * */
export const DOCUMENT_DESCRIPTION_MAX_LENGTH = 100;

/** PDF 파일명 최대 길이
 * 사용처:
 *  PdfAsset
 * */
export const PDF_DESCRIPTION_MIN_LENGTH = 20;
export const PDF_DESCRIPTION_MAX_LENGTH = 50;
export const PDF_DESCRIPTION_MAX_LENGTH_MOBILE = 38;
export const PDF_DESCRIPTION_MAX_DISPLAY_LENGTH_DESKTOP = 80;
export const PDF_DESCRIPTION_MAX_DISPLAY_LENGTH_MOBILE = 40;

/** TextBlock PARAGRAPH 최대 길이
 * 사용처: 
 *  TextBlock
 * */
export const TEXTBLOCK_PARAGRAPH_MAX_LENGTH = 10000;

/** TextBlock CAPTION 최대 길이
 * 사용처: 
 *  TextBlock
 * */
export const TEXTBLOCK_CAPTION_MAX_LENGTH = 100;

/** TextBlock IMAGE 타입 최대 개수 (본문 대비 이미지 과다 방지)
 * 사용처:
 *  TextBlock
 * */
export const TEXTBLOCK_IMAGE_MAX_COUNT = 3;

/** TextBlock LINK url(href) 최대 길이
 * 사용처:
 *  TextBlock
 * */
export const TEXTBLOCK_LINK_URL_MAX_LENGTH = 500;

/** TextBlock LINK 라벨(caption) 최대 길이
 * 사용처:
 *  TextBlock
 * */
export const TEXTBLOCK_LINK_LABEL_MAX_LENGTH = 100;

/** Member Description 최대 길이
 * 사용처: 
 *  MemberInfo
 * */
export const MEMBER_DESCRIPTION_MAX_LENGTH = 1000;

/** Search Preview Title·SubTitle 최대 길이
 * 사용처:
 *  ChangeShareModal · ChangeShareModalMobile · ChangeSearchEngineModal · ChangeSearchEngineModalMobile
 * */
export const SEO_TITLE_MAX_LENGTH = 40;

/** Search Engine Description 입력·저장 최대 길이
 * 사용처:
 *  ChangeSearchEngineModal · ChangeSearchEngineModalMobile
 * */
export const SEO_DESCRIPTION_MAX_LENGTH = 3000;

/** 외부 검색 `<meta name="description">` 출력 최대 길이
 * 사용처:
 *  prerender
 * */
export const SEO_META_DESCRIPTION_MAX_LENGTH = 400;

/** System Alert 메시지 최대 길이
 * 사용처: 
 *  SystemAlertViewer
 * */
export const SYSTEM_ALERT_MESSAGE_MAX_LENGTH = 1000;

/** Support 문의 본문 최대 길이
 * 사용처:
 *  SupportModal, SupportModalMobile
 * */
export const SUPPORT_MESSAGE_MAX_LENGTH = 350;

/** TextBox 내용 최대 길이
 * 사용처: 
 *  TextBox
 *  TextBoxMobile
 *  OnBoardingTextBox
 *  OnBoardingTextBoxMobile
 * */
export const TEXTBOX_CONTENT_MAX_LENGTH = 3000;


/** Work Description 최대 길이
 * 사용처: 
 *  WorkViewer
 *  WorkViewerMobile
 *  WorkInfo
 *  WorkInfoMobile
 *  WorkInfoLeft
 *  WorkInfoRight
 * */
export const WORK_DESCRIPTION_MAX_LENGTH = 1000;

/** Work Description 최대 행 수
 * 사용처: 
 *  WorkInfoLeft
 *  WorkInfoRight
 * */
export const WORK_DESCRIPTION_MAX_ROWS = 12;

/** Description 최대 행 수
 * 사용처: 
 *  WorkViewer
 *  TextBlock
 * */
export const DESCRIPTION_MAX_ROWS = 100;

/** Career content / contentEn 최대 행 수 (Enter 기준)
 * 사용처:
 *  MoleculeValue (CareerInfo)
 * */
export const CAREER_CONTENT_MAX_ROWS = 2;

/** Poll 기타 입력 최대 길이
 * 사용처: 
 *  PollData
 * */
export const POLL_OTHER_MAX_LENGTH = 50;
export const POLL_OTHER_MAX_LENGTH_LONG = 100;

// ==================== 파일 크기 제한 ====================
/** 일반 파일 크기 제한 (30MB)
 * 사용처: 
 *  useImage
 *  useOnBoardImageFileUpload
 * */
export const FILE_MAX_SIZE = 1024 * 1024 * 30;

/** 파일 크기 제한 표시용 텍스트 (30MB)
 * 사용처: 
 *  useGlobalError
 * */
export const FILE_MAX_SIZE_TEXT = '30MB';

/** SEO / OG 이미지 업로드 크기 제한 (500KB) */
export const SEO_IMAGE_MAX_SIZE = 1024 * 500;
export const SEO_IMAGE_MAX_SIZE_TEXT = '500KB';

// ==================== 목록·Import·Indexing 표시 길이 ====================
/** Import Station Text 선택 목록 제목 표시 최대 길이
 * 사용처:
 *  SimpleText (ImportStationTextMain, ImportStationTextMainMobile)
 * */
export const IMPORT_STATION_TEXT_TITLE_MAX_LENGTH = 14;

/** Import Station Text 선택 목록 저자 표시 최대 길이
 * 사용처:
 *  SimpleText (ImportStationTextMain, ImportStationTextMainMobile)
 * */
export const IMPORT_STATION_TEXT_AUTHOR_MAX_LENGTH = 10;

/** Import Station Detail 행 설명 표시 최대 길이
 * 사용처:
 *  SimpleWorkDetailForPE, SimpleWorkDetailForFormationItem
 * */
export const IMPORT_STATION_DETAIL_DESCRIPTION_MAX_LENGTH = 24;

// ==================== 벌크 업로드 ====================
/** 한 번에 업로드 가능한 이미지 최대 개수
 * 사용처:
 *  Work/Detail 벌크(WorkList, WorkDetailList 등), PE 벌크·Work Import(ProjectElementList, Import Station 등)
 *  alertMessages BULK_UPLOAD_IMAGE_MAX_EXCEEDED
 * */
export const BULK_UPLOAD_IMAGE_MAX_COUNT = 20;

// ==================== 작품 목록 내보내기 (PDF / Excel) ====================
/** 한 번에 내보낼 수 있는 Work 최대 개수 (UI 검증과 동기화)
 * 사용처:
 *  WorkListPdfModalCreate, WorkListPdfModalSelect, SimpleWorkForExport (PDF 선택)
 *  alertMessages WORK_LIST_EXPORT_MAX_ITEMS
 */
export const WORK_LIST_EXPORT_MAX_ROWS = 50;

/** Import Station 스토어 `selectedDataList` 길이 상한. PE 벌크 UI(`BULK_UPLOAD_IMAGE_MAX_COUNT`)와 맞춘다. PDF/Excel 내보내기는 `exportStationWorkStore`와 `WORK_LIST_EXPORT_MAX_ROWS`를 따로 쓴다. */
export const IMPORT_STATION_SELECTED_MAX_COUNT = BULK_UPLOAD_IMAGE_MAX_COUNT;

// ==================== Venue ====================
/** venueCode 최대 길이 (백엔드와 동일)
 * 사용처: VenueViewer
 */
export const VENUE_CODE_MAX_LENGTH = 100;

/** venueCode 허용 패턴. 소문자 입력 가능, 서버가 대문자로 저장
 * 사용처: VenueViewer
 */
export const VENUE_CODE_PATTERN = /^[A-Za-z0-9][A-Za-z0-9_-]*$/;

/** POST /api/v1/venue/bulk 최대 행 수
 * 사용처: VenueList
 */
export const VENUE_BULK_MAX_ROWS = 1000;

/** Venue Excel import 파일 크기 제한 */
export const VENUE_BULK_FILE_MAX_SIZE = 1024 * 1024 * 5;
export const VENUE_BULK_FILE_MAX_SIZE_TEXT = '5MB';

// ==================== Exhibition ====================
export const EXHIBITION_BULK_MAX_ROWS = 1000;
export const EXHIBITION_BULK_FILE_MAX_SIZE = 1024 * 1024 * 5;
export const EXHIBITION_BULK_FILE_MAX_SIZE_TEXT = '5MB';

// ==================== Career ====================
export const CAREER_BULK_MAX_ROWS = 1000;
export const CAREER_BULK_FILE_MAX_SIZE = 1024 * 1024 * 5;
export const CAREER_BULK_FILE_MAX_SIZE_TEXT = '5MB';
